import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FeildActivity_Interface,Empty_FeildActivity_Interface } from 'src/app/Interface/FeildActivity_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { FeildActivityService } from 'src/app/Service/FeildActivity/FeildActivity.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-FeildActiviryAdd',
  templateUrl: './FeildActiviryAdd.component.html',
  styleUrls: ['./FeildActiviryAdd.component.scss']
})
export class FeildActiviryAddComponent implements OnInit {

  Token:String=""

  constructor(
    private FeildActivity_Service:FeildActivityService,
    private Nav_Service:NavService,
    private Alertify_Service:AlertifyService
  ) { }

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');

    this.AddNewFeildActivity=new FormGroup({
      id :new FormControl(),

      Title:new FormControl(null,Validators.required),
    })


    this.Nav_Service.CheckValidPage(this.Token,17).subscribe(
      data=>{

      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )


  }


  //#region  Form Add

  AddNewFeildActivity:FormGroup;


  get_Form_Title(){
    return this.AddNewFeildActivity.get('Title') as FormControl;
  }

  //#endregion

  InProccessing:boolean=false

  SubmitAddNewFeildActivity(){
    var Record:FeildActivity_Interface =Empty_FeildActivity_Interface()
    Record.id=0
    Record.code=""
    Record.title=this.get_Form_Title().value
    this.InProccessing=true
    this.FeildActivity_Service.AddFeildActivity(Record,this.Token).subscribe(
      data=>{
        this.InProccessing=false
        if(data.id==-2){
          this.Alertify_Service.ErrorMessage("The field of activity already exists in the list")
        }
        else{
          this.AddNewFeildActivity.reset()
          this.Alertify_Service.SuccessMessage("The information was registered successfully")
        }
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }



}
